/**
 * Helper
 */
var helper = require('../../helper'),
		dataTables_buttons = [

			{
				extend: 'csv',
				text: 'Export as CSV',
				exportOptions: {
					columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
				},
				className: 'btn btn-default'
			},
			{
				extend: 'pdf',
				text: 'Export as PDF',
				exportOptions: {
					columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
				},
				className: 'btn btn-default'
			},
			{
				extend: 'print',
				text: 'Print table',
				exportOptions: {
					columns: [0, 1, 2, 3, 4, 5, 6, 7, 8]
				},
				className: 'btn btn-default'
			},
			{
				extend: 'colvis',
				className: 'btn btn-default'
			}

		];

$(function() {
    var $datatable = $('#datatable-all-property-expenditures-items'),
        propertyId = $('#datatable-all-property-expenditures-items').data('property-id'),
        columns = [
	        { data: 'categoryName', name: 'categoryName' },
	        { data: 'typeName', name: 'typeName' },
	        { data: 'status', name: 'status', searchable: false },
            { data: 'bankAccountName', name: 'bankAccountName' },
	        { data: 'amount_paid', name: 'amount_paid' },
	        { data: 'date', name: 'date' },
	        { data: 'creditor', name: 'creditor' },
	        { data: 'invoice_number', name: 'invoice_number' },
	        { data: 'purchase_order_number', name: 'purchase_order_number' },
            { data: 'actions', name: 'actions', orderable: false, searchable: false, className : "action" }
        ], $dt;

    $dt = $datatable.DataTable({
        "dom": "<'dt-toolbar'lfB>tr<'row'<'col-sm-5'i><'col-sm-7'p>>",
	    "buttons": dataTables_buttons,
        "processing": true,
        "serverSide": true,
        "responsive": true,
        "lengthMenu": [[ 30, 10, 25, 50, 75, 100], [ 30, 10, 25, 50, 75, 100]],
        "ajax": {
            "url": helper.getOrigin() + "/api/properties/" + propertyId + "/expenditures-items",
            "method": 'POST',
	        "data": function ( d ) {
		        d.category_id = $('select[id=category_id]').val();
		        d.type_id = $('select[id=type_id]').val();
		        d.status = $('select[id=status]').val();
		        d.bank_account_id = $('select[id=bank_account_id]').val();
		        d.creditor = $('input[id=creditor]').val();
	        }
        },
        "bAutoWidth" : false,
        "order": [[ 5, "desc" ]],
        "columns": columns,

        'columnDefs': [{
            'targets': 4,
            'className': 'dt-body-center tiny-column',
            'render': function (data, type, full, meta){
	            return '&pound' + parseFloat(data).toFixed(2);
            }
        },
        ]
    });

	$('#search-form').on('submit', function(e) {
		$dt.draw();
		e.preventDefault();
	});

});
